/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Icon } from '@fluentui/react/lib/Icon';
import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { Page } from 'src/core/components/Page';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getScopedTheme } from 'src/core/themes/luisStylist';
import styled from 'styled-components';

const messages = defineMessages({
    pageTitle: {
        id: 'portal.sessionExpiredPage.pageTitle',
        defaultMessage: 'Session expired!'
    },
    pageHeader: {
        id: 'portal.sessionExpiredPage.pageHeader',
        defaultMessage: 'Your session has expired. Please refresh the page to continue your session.'
    },
    refresh: {
        id: 'portal.sessionExpiredPage.refresh',
        defaultMessage: 'Refresh'
    }
});

const theme = getScopedTheme('SessionExpiredPage');
const CenteredText = styled(LuisText)`
    textalign: center;
    marginbottom: ${theme.textMargin};
`;

/**
 * Renders a simple session expired page.
 */
export const SessionExpiredPage = () => {
    const { localize } = useLocalization();
    const { dispatcher } = useGlobalState();

    return (
        <Page pageName="NotFoundPage" size="container" title={localize(messages.pageTitle)}>
            <Stack verticalFill verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: '22px' }}>
                <Icon iconName="Info" styles={{ root: { fontSize: '125px', marginBottom: '35px' } }} />

                <CenteredText variant="xLargePlus">{localize(messages.pageHeader)}</CenteredText>

                <PrimaryButton onClick={() => dispatcher.dispatch('login')}>{localize(messages.refresh)}</PrimaryButton>
            </Stack>
        </Page>
    );
};
